import { CircularProgress } from '@material-ui/core';
import React, { FC } from 'react';
import { ProcessStatus } from 'styles/ProcessStatus';

export const Loading: FC = () => {
  return (
    <ProcessStatus>
      <CircularProgress size={50} />
    </ProcessStatus>
  );
};
